/**
 * Joins Polish single-letter conjunctions/prepositions (a, i, o, u, w, z) to the
 * word that follows them with a non-breaking space, so they never hang alone
 * at the end of a line ("wiszące spójniki").
 */
(function () {
  var LETTERS = 'aiouwzAIOUWZ';
  var PATTERN = new RegExp('(^|[\\s\\u00A0])([' + LETTERS + '])[ \\t]+(?=\\S)', 'g');
  var SKIP_TAGS = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, INPUT: 1, CODE: 1, PRE: 1, NOSCRIPT: 1 };
  var processed = new WeakSet();

  function processTextNode(node) {
    if (processed.has(node)) return;
    processed.add(node);

    var value = node.nodeValue;
    if (!value || value.indexOf(' ') === -1) return;

    // The pattern consumes the whitespace *before* the letter, so in a run
    // like "jak i w pełni" the match for "i" eats the space that "w" needs.
    // Repeating until nothing changes catches every letter in such a run.
    var updated = value;
    var previous;
    do {
      previous = updated;
      updated = updated.replace(PATTERN, '$1$2 ');
    } while (updated !== previous);

    if (updated !== value) {
      node.nodeValue = updated;
    }
  }

  function walk(root) {
    if (!root) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        var parent = node.parentElement;
        if (!parent || SKIP_TAGS[parent.tagName] || parent.isContentEditable) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      },
    });

    var node;
    while ((node = walker.nextNode())) {
      processTextNode(node);
    }
  }

  function run(root) {
    walk(root || document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      run(document.body);
    });
  } else {
    run(document.body);
  }

  document.addEventListener('shopify:section:load', function (event) {
    run(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    run(event.target);
  });
})();
